import { useState, useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import { apiUc } from '../http';

/** @typedef {'limited-by-queue' | 'queue-sum' | 'limited-by-agent'} TypesOfLimitation */

const limitationOptions = [
  {
    label: 'Somatória de todas as filas',
    value: 'queue-sum'
  },
  {
    label: 'Vagas limitadas por fila',
    value: 'limited-by-queue'
  },
  {
    label: 'Quantidade de vagas limitadas por atendente',
    value: 'limited-by-agent'
  }
];

export const useChatTypeOfLimitation = () => {
  const [currentOption, setCurrentOption] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      const { data } = await apiUc.get('/api/config/filas/geral');

      if (data?.data?.typeOfLimitation) {
        const option = limitationOptions.find(
          (opt) => opt.value === data.data.typeOfLimitation
        );
        setCurrentOption(option || null);
      }
    } catch (err) {
      toast.error(
        'Não foi possível resgatar a configuração de modo de limitação',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
    } finally {
      setIsLoading(false);
    }
  }, []);

  const update = useCallback(async (option) => {
    if (!option?.value) {
      toast.error('O modo de limitação não foi informado', {
        autoClose: 3000,
        closeOnClick: true
      });
      return false;
    }

    setIsLoading(true);
    try {
      await apiUc.put('/api/config/filas/geral', {
        typeOfLimitation: option.value
      });

      setCurrentOption(
        limitationOptions.find((opt) => opt.value === option.value)
      );
      toast.info('Modo de limitação alterado com sucesso!', {
        autoClose: 3000,
        closeOnClick: true
      });
      return true;
    } catch (err) {
      toast.error('Não foi possível alterar o modo de limitação', {
        autoClose: 3000,
        closeOnClick: true
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    options: limitationOptions,
    currentOption,
    update,
    isLoading
  };
};
